// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"482":"717ac082","783":"31f2ff51","919":"8fc7e14e"}[chunkId] + ".chunk.js";
};